/* eslint-disable */

import Vue from 'vue';
import Router from 'vue-router';
import { includes, has } from 'lodash';

import TheHeader from '@/components/TheHeader';
import TheFooter from '@/components/TheFooter';

import store from '@/store';
import i18n from '@/i18n';
import { URLS } from '@/util';

Vue.use(Router);

// lazy loaded components
const LoginBridge = () =>
  import( /* webpackChunkName: "group-0" */ '@/views/LoginBridge');
const ProjectsLayout = () =>
  import( /* webpackChunkName: "group-0" */ '@/views/ProjectsLayout');
const Login = () =>
  import( /* webpackChunkName: "group-0" */ '@/views/Login');
const PageNotFound = () =>
  import( /* webpackChunkName: "group-0" */ '@/views/PageNotFound');
const UserLocked = () =>
  import( /* webpackChunkName: "group-0" */ '@/views/UserLocked');
const RestorePasswordRequest = () =>
  import( /* webpackChunkName: "group-0" */ '@/views/RestorePasswordRequest');
const RestorePassword = () =>
  import( /* webpackChunkName: "group-0" */ '@/views/RestorePassword');

export const PAGE_NOT_FOUND = 'pageNotFound';
export const PAGE_NOT_FOUND_ROUTE = '/error/404';
const INSTANCES = ['mfar', 'mfarevents', 'gecp'];

const router = new Router({
  routes: [{
    path: '/login-bridge',
    name: 'login-bridge',
    components: {
      TheHeader,
      TheFooter,
      default: LoginBridge,
    },
    props: {
      default: (route) => {
        let token;
        if (has(route, 'query.token_type') && has(route, 'query.access_token')) {
          token = {
            token_type: route.query.token_type,
            access_token: route.query.access_token,
          }
        }

        return {
          instance: route.query.instance || null,
          username: route.query.username || null,
          redirectUrl: route.query.redirectUrl || null,
          token,
        };
      },
    },
  },
  {
    path: '/locked',
    name: 'locked',
    components: {
      default: UserLocked,
      TheHeader,
      TheFooter,
    },
    props: {
      default: true,
      TheHeader: false,
      TheFooter: false,
    },
  },
  {
    path: '/:instance',
    alias: '/:instance/en',
    name: 'login',
    components: {
      default: Login,
      TheHeader,
      TheFooter,
    },
    props: {
      default: (route) => {
        const redirectUrl = route.query.redirectUrl && atob(route.query.redirectUrl);

        return {
          instance: route.params.instance || null,
          redirectUrl: redirectUrl || null,
        };
      },
      TheHeader: false,
      TheFooter: false,
    },
  },
  {
    path: '/:instance/projects',
    name: 'projects',
    components: {
      default: ProjectsLayout,
      TheHeader,
      TheFooter,
    },
    props: {
      default: () => { },
    },
  },
  {
    path: '/:instance/restore-password-request',
    alias: '/:instance/restore-password-request/en',
    name: 'restore-password-request',
    components: {
      default: RestorePasswordRequest,
      TheHeader,
      TheFooter,
    },
    props: {
      default: (route) => {
        return {
          instance: route.params.instance || null,
          redirectUrl: route.query.redirectUrl || null,
          autoLogin: route.query.autoLogin || null,
        };
      },
    },
  },
  {
    path: '/:instance/restore-password',
    alias: '/:instance/restore-password/en',
    name: 'restore-password',
    components: {
      default: RestorePassword,
      TheHeader,
      TheFooter,
    },
    props: {
      default: (route) => {
        if (!route.query.userId
          || !route.query.userName
          || !route.query.userUsername
          || !route.query.userMail
          || !route.params.instance) {
          window.location = URLS.defaultRedirect;
        }

        return {
          validUntil: route.query.validUntil || null,
          userId: route.query.userId || null,
          userUsername: route.query.userUsername || null,
          userMail: route.query.userMail || null,
          userName: route.query.userName || null,
          instance: route.params.instance || null,
          redirectUrl: route.query.redirectUrl || null,
          autoLogin: route.query.autoLogin || null,
        };
      },
      TheHeader: false,
      TheFooter: false,
    },
  },
  {
    path: '*',
    redirect: PAGE_NOT_FOUND,
  },
  {
    path: PAGE_NOT_FOUND_ROUTE,
    name: PAGE_NOT_FOUND,
    components: {
      default: PageNotFound,
      TheHeader,
      TheFooter,
    },
  },
  ],
});

router.beforeEach((to, from, next) => {
  const loginIsDone = store.getters['login/isDone'];

  const { locale } = store.state;
  i18n.locale = locale;

  const setLocale = () => {
    if (to.path.includes('/en')) {
      const locale = 'en';

      i18n.locale = locale;
      store.commit('setLocale', locale);
    } else {
      store.commit('setLocale', 'es');
    }
  }

  if (to.name === 'login' || to.name === 'loginEN') {
    setLocale();

    const instance = to.params.instance;
    const instanceIsValid = includes(INSTANCES, instance);

    store.commit('login/setInstance', instance);

    if (instanceIsValid) {
      next();
    } else {
      next(PAGE_NOT_FOUND_ROUTE)
    }
  }

  if (to.name === 'login-bridge') {
    const instance = to.query.instance;
    const instanceIsValid = includes(INSTANCES, instance);

    store.commit('login/setInstance', instance);

    if (instanceIsValid) {
      next();
    } else {
      next(PAGE_NOT_FOUND_ROUTE)
    }
  }

  if (to.name === 'projects') {
    if (loginIsDone) {
      next();
    } else {
      next(PAGE_NOT_FOUND_ROUTE)
    }
  }

  if (to.name === 'locked') {
    next();
  }

  if (to.name === 'restore-password-request' || to.name === 'restore-password') {
    setLocale();

    const instance = to.params.instance;
    store.commit('login/setInstance', instance);

    next();
  }

  if (to.name === PAGE_NOT_FOUND) {
    next();
  }
});

export default router;
